/**
 * Ryan O'Dowd
 * 2024-08-02
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const DOT_SIZE = 6;

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    dialogTitle: {
      color: isDarkMode ? colors.white : colors.black,
      fontSize: globalScale * 22,
      fontFamily: fonts.secondaryBold,
      marginBottom: globalScale * 8,
    },
    wordAndControlsWrapper: {
      borderWidth: 2,
      borderColor: isDarkMode ? colors.primaryLight : colors.primary,
      borderRadius: 8,
      marginTop: 16,
    },
    wordContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: `${colors.primary}44`,
      width: '100%',
    },
    centerLine: {
      position: 'absolute',
      left: '50%',
      width: 2,
      height: '15%',
      backgroundColor: isDarkMode ? colors.primaryLight : colors.primary,
    },
    centerLineTop: {
      top: 0,
    },
    centerLineBottom: {
      bottom: 0,
    },
    startAnimationView: {
      position: 'absolute',
      height: '100%',
      marginHorizontal: globalScale * 16,
      backgroundColor: `${colors.primaryDark}44`,
    },
    mainWord: {
      color: isDarkMode ? colors.white : colors.black,
      fontSize: globalScale * 30,
      margin: globalScale * 8,
    },
    statsWrapper: {
      position: 'absolute',
      padding: 6,
      right: 0,
      height: '100%',
    },
    statsInner: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      height: '100%',
    },
    spritzWpm: {
      color: isDarkMode ? colors.primaryLight : colors.primaryDark,
      fontSize: globalScale * 12,
    },
    currentVerseNumber: {
      color: isDarkMode ? colors.primaryLight : colors.primaryDark,
      fontSize: globalScale * 12,
    },
    tableOfContentsContainer: {
      marginTop: 16,
    },
    tableOfContents: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    sectionWrapper: {
      display: 'flex',
      maxWidth: '100%',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
    headingWrapper: {
      display: 'flex',
      flexShrink: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginVertical: 4,
    },
    headingText: {
      color: isDarkMode ? colors.primaryLight : colors.primary,
      fontSize: globalScale * 14,
      fontFamily: fonts.secondaryBold,
      maxWidth: '100%',
    },
    sectionProgressWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      marginTop: 4,
    },
    verseDot: {
      width: globalScale * DOT_SIZE,
      height: globalScale * DOT_SIZE,
      margin: globalScale * 2,
      borderRadius: globalScale * (DOT_SIZE / 2),
      backgroundColor: colors.lightGray,
    },
    verseDotComplete: {
      backgroundColor: colors.accentDark,
    },
    verseDotInProgress: {
      backgroundColor: isDarkMode ? colors.primaryLight : colors.primary,
    },
    otherOptionsContainer: {
      marginTop: 16,
    },
    controls: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      alignSelf: 'center',
    },
    selectedMenuItem: {
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
